import { useState } from "react";
import Drafts from "./Drafts";
import DraftProgress from "./DraftProgress";

function DraftMain({setActiveTab }) {

  const [selectedDraft, setSelectedDraft] = useState(null);

  return (
    <>
      {!selectedDraft ? (
        <Drafts
          setSelectedDraft={setSelectedDraft}
        />
      ) : (
        <DraftProgress
          selectedDraft={selectedDraft}
          onBack={() => setSelectedDraft(null)}
           setActiveTab={setActiveTab}
        />
      )}
    </>
  );
}

export default DraftMain;